import { Link } from "react-router-dom";
import seo from "@/seo/pages.json";
import { SEO_LANDINGS } from "@/pages/SeoLanding";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between text-xs text-[#52525B]">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <span data-testid="footer-copyright">© Get Set Design 2026</span>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="uppercase tracking-[0.2em] text-[#0A0A0B] hover:text-[#ED5A24] underline-offset-4 hover:underline transition-colors duration-200"
          >
            Terms & conditions
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="uppercase tracking-[0.2em] text-[#0A0A0B] hover:text-[#ED5A24] underline-offset-4 hover:underline transition-colors duration-200"
          >
            Privacy policy
          </Link>
        </div>
        <span className="uppercase tracking-[0.2em]" data-testid="footer-credit">
          Created by <span className="font-bold text-[#0A0A0B]">Get Set Design</span>
        </span>
      </div>
      <nav className="max-w-7xl mx-auto px-6 lg:px-8 pb-5 flex flex-wrap gap-x-5 gap-y-1 text-xs text-[#52525B]" data-testid="footer-guides" aria-label="Guides">
        {SEO_LANDINGS.map((r) => (
          <Link key={r} to={r} data-testid={`footer-guide-${r.slice(1)}`} className="hover:text-[#ED5A24] transition-colors duration-200">{seo.pages[r].eyebrow}</Link>
        ))}
      </nav>
    </footer>
  );
}
